import { api_host } from '../common/globals/constants';

/**
 * Fetch Interceptor
 * Intercepta todas las peticiones fetch para agregar parámetros de consulta
 * como clienteUsuarioId, adminId y fechaLogin.
 * Estos parámetros se obtienen del sessionStorage.
 */
export function execFetchInterceptor() {
  const { fetch: originalFetch } = window;

  window.fetch = async (...args) => {
    let [resource, config] = args;

    const API_BASE_URL = api_host;
    /**
     * Valida si la URL de la petición es una llamada a la API Atentus.
     * Valida que el userId esté en sessionStorage.
     * Esto es para evitar que se agreguen parámetros a las URLs de autenticación u otras que sean públicas.
     */
    const clienteUsuarioId = sessionStorage.getItem('user');
    const isApiCall =
      resource.toString().startsWith(API_BASE_URL) && Boolean(clienteUsuarioId);

    if (!isApiCall) {
      return originalFetch(...args);
    }

    /**
     * Agrega los parámetros de consulta a la URL de la petición.
     */
    const adminId = sessionStorage.getItem('admin_id');
    const fechaLogin = sessionStorage.getItem('fechaLogin');

    /** Toma los parámetros originales de la consulta y agrega los parámetros de consulta a la URL de la petición. */
    const originalParams = new URL(resource).searchParams;
    const originalUrl = new URL(resource).origin + new URL(resource).pathname;

    const newParams = new URLSearchParams(originalParams.toString());
    newParams.set('cuid', clienteUsuarioId);
    newParams.set('faid', fechaLogin);
    if (adminId) {
      newParams.set('admid', adminId);
    }

    resource = `${originalUrl}?${newParams.toString()}`;

    const response = await originalFetch(resource, config);
    return response;
  };
}
